import type { ReactNode } from "react";
import { SiteNav } from "./SiteNav";
import { SiteFooter } from "./SiteFooter";

export function PageShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background">
      <SiteNav />
      <main id="main-content">{children}</main>
      <SiteFooter />
    </div>
  );
}

export function PageHero({
  eyebrow,
  h1,
  intro,
  children,
}: {
  eyebrow: string;
  h1: string;
  intro?: string;
  children?: ReactNode;
}) {
  return (
    <section className="relative overflow-hidden pt-28 pb-12 md:pt-36 md:pb-16">
      <div className="mx-auto max-w-4xl px-5 text-center md:px-8">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary/25 bg-primary/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-primary backdrop-blur-sm">
          <span className="h-1.5 w-1.5 rounded-full bg-accent shadow-[0_0_8px_var(--accent)]" />
          {eyebrow}
        </span>
        <h1 className="mt-6 font-display text-4xl font-bold leading-[1.05] tracking-tight text-secondary text-balance md:text-5xl lg:text-6xl">
          {h1}
        </h1>
        {intro && <p className="mx-auto mt-5 max-w-2xl text-lg text-secondary/75">{intro}</p>}
        {children && <div className="mt-8 flex justify-center">{children}</div>}
      </div>
    </section>
  );
}
